import { render, staticRenderFns } from "./ClienteColaborador.vue?vue&type=template&id=b0775930"
import script from "./ClienteColaborador.vue?vue&type=script&lang=js"
export * from "./ClienteColaborador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports